/* eslint-disable react/no-danger */
import * as React from 'react';
import { Helmet } from 'react-helmet';

export default function Seo({ page, lang, dir }) {
  const image = page?.socialMediaImage?.url || '';
  let title = page.metadataTitle || page.title;
  const description = page.metadataTitle || page.metadataDescription;
  const keywords = page.metadataKeywords;
  const metaDescription = description; // || site.siteMetadata.description
  const defaultTitle = ''; // site.siteMetadata?.title
  title = `${title} - Dubai Sports World`;

  return (
    <Helmet
      htmlAttributes={{
        lang,
        dir,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `og:image`,
          content: image,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat([])}
    >
      <link
        rel="preload"
        as="image"
        href="https://media.umbraco.io/dev-dwtc/uevfe5wx/dsw_logo.png"
        type="image/png"
      />
      <link
        rel="preload"
        as="image"
        href="https://media.umbraco.io/dev-dwtc/uevfe5wx/dsw_logo.png"
        type="image/png"
      />
      <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5BMBZ9');`}</script>
    </Helmet>
  );
}
